module.exports = __webpack_public_path__ + "img/Img19_214884_CeEu-4-45A3-51.cb7ea039.jpg";